import { ViewRoom } from '@xeetr/types/models'

import HeaderBadges from '../common/HeaderBadges'
import OrderButtons from '../common/OrderButtons'

import { Badge } from '@/components/ui/badge'

interface Props {
  room: ViewRoom
  roomIndex: number
  rooms: ViewRoom[]
  swapRoom: (fromIndex: number, toIndex: number) => void
}

const RoomHeader = ({ room, roomIndex, rooms, swapRoom }: Props) => {
  const orderUp = () => {
    if (roomIndex === 0) return
    swapRoom(roomIndex, roomIndex - 1)
  }

  const orderDown = () => {
    if (roomIndex === rooms.length - 1) return
    swapRoom(roomIndex, roomIndex + 1)
  }

  return (
    <div className="flex w-full justify-between">
      <div className="ml-2 flex flex-col gap-1">
        <span className="text-2xl font-normal">{room.name}</span>
        <div className="flex flex-wrap items-center gap-4 text-center">
          <div className="flex items-center gap-1">
            <span className="font-normal">Kapazität:</span>
            <Badge variant="default">{room.settings.capacity}</Badge>
          </div>
          {room.settings.default && <Badge variant="secondary">Standard</Badge>}
          <HeaderBadges values={room.tables} />
        </div>
      </div>
      <OrderButtons
        disabledUp={roomIndex === 0}
        onUp={orderUp}
        disabledDown={roomIndex === rooms.length - 1}
        onDown={orderDown}
      />
    </div>
  )
}

export default RoomHeader
